import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";

import { ConversionRateOverviewContainer } from "../../widgets/conversion-rate/ConversionRateOverviewContainer";
import { DeviceDistributionComparisonWidget } from "../../widgets/device-distribution/comparison/DeviceDistributionComparisonWidget";
import { HighLevelMetricsComparison } from "../../widgets/high-level-metrics/comparison/HighLevelMetricsComparison";
import { KeySizingIndicatorsComparisonWidget } from "../../widgets/key-indicators/comparison/KeySizingIndicatorsComparisonWidget";
import { MarketDifficultyComparisonWidget } from "../../widgets/market-difficulty/comparison/MarketDifficultyComparisonWidget";
import { AudienceComparisonWidget } from "../../widgets/marketSize/comparison/AudienceComparisonWidget";
import { TopCountriesComparisonWidget } from "../../widgets/top-countries/comparison/TopCountriesComparisonWidget";
import { MarketConsolidationComparisonWidget } from "../market-consolidation/MarketConsolidationComparisonWidget";
import { TopPlayersComparisonWidget } from "../top-players/comparison/TopPlayersComparisonWidget";

import { MarketShareSectionTitle, MarketSizeSectionTitle, PageContainer, MarketAssessmentSectionTitle } from "./styled";

export const MarketResearchOverviewComparison = () => {
    const { categories, hasSelectedCategoryWithSegments } = useCategoriesComparison();
    const hasCustomCategorySelected = categories.some(({ category }) => category.isCustomCategory);
    const showMarketAssessmentSection = !hasSelectedCategoryWithSegments || !hasCustomCategorySelected;

    return (
        <PageContainer>
            <MarketSizeSectionTitle />
            {!hasSelectedCategoryWithSegments && <AudienceComparisonWidget />}
            <KeySizingIndicatorsComparisonWidget />
            <HighLevelMetricsComparison />
            <ConversionRateOverviewContainer />
            <MarketShareSectionTitle />
            <TopPlayersComparisonWidget />
            {!hasSelectedCategoryWithSegments && <TopCountriesComparisonWidget />}
            {!hasSelectedCategoryWithSegments && <DeviceDistributionComparisonWidget />}
            {showMarketAssessmentSection && <MarketAssessmentSectionTitle />}
            {!hasSelectedCategoryWithSegments && <MarketDifficultyComparisonWidget />}
            {!hasCustomCategorySelected ? <MarketConsolidationComparisonWidget /> : null}
        </PageContainer>
    );
};
